
import { GameConfig } from "Data/GameConfig";
import type { LocationID } from "Data/GameConfig";
import { TweenLite } from "gsap/TweenLite";
import { makeSprite } from "html-living-framework/lib/Utils/PixiUtils";
import type { ILevelState } from "Interfaces/ILevelState";
import type { ILocationConfig } from "Interfaces/ILocationConfig";
import type { INPCConfig } from "Interfaces/INPCConfig";

export abstract class InteriorNPC extends PIXI.Container {
    protected bg?: PIXI.Sprite;
    protected sprite?: PIXI.Sprite;
    protected spriteContainer = this.addChild(new PIXI.Container());

    protected abstract right: number;
    protected abstract bottom: number;

    public init(pSize: PIXI.Point, pData: ILevelState) {
        const id: LocationID = pData.id;
        const config: ILocationConfig = GameConfig.locations[id];
        const npcconfig: INPCConfig = config.npc;
        const pose = (pData.allItemsFound ? npcconfig.poses.excited : npcconfig.poses.neutral);
        const filename = pData.id + "/" + pose.sprite;
        // this.bg = this.spriteContainer.addChild(makeSprite("container", SPRITESHEET_UI));
        // this.bg.anchor.set(0.5, 1);

        this.sprite = this.spriteContainer.addChild(makeSprite(filename, GameConfig.spritesheets[id]));
        this.sprite.anchor.set(0.5, 1);
        if (pose.position !== undefined) {
            this.sprite.position.set(pose.position.x, pose.position.y);
        }
        this.spriteContainer.position.set(
            (1024 / 2) - this.right,
            (768 / 2) - this.bottom,
        );
        return this;
    }

    public animateIn() {
        TweenLite.from(this, 0.5, {pixi: {positionY: 40 }});
    }

    public onResize(pSize: PIXI.Point) {
        //
    }

    public destroy(pOptions?: PIXI.DestroyOptions | boolean) {
        super.destroy(pOptions);
    }
}
